import { render } from "./enquire-form.vue?vue&type=template&id=8a3585da&ts=true"
import script from "./enquire-form.vue?vue&type=script&lang=ts"
export * from "./enquire-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__